import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_label = _resolveComponent("bs5-base-label")!
  const _component_bs5_cancel_button = _resolveComponent("bs5-cancel-button")!
  const _component_bs5_save_button = _resolveComponent("bs5-save-button")!
  const _component_bs5_base_modal = _resolveComponent("bs5-base-modal")!

  return (_openBlock(), _createBlock(_component_bs5_base_modal, {
    title: "Assign Distributor",
    visible: _ctx.visible,
    onClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.assignDistributor && _ctx.assignDistributor(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_bs5_base_label, { for: "distributor" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Select Distributor")
            ])),
            _: 1
          }),
          (_ctx.distributors?.length > 0)
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                id: "distributor",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDistributorId) = $event)),
                class: "form-select"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distributors, (distributor) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: distributor.id,
                    value: distributor.id
                  }, _toDisplayString(distributor.name), 9, _hoisted_2))
                }), 128))
              ], 512)), [
                [_vModelSelect, _ctx.selectedDistributorId]
              ])
            : (_openBlock(), _createElementBlock("span", _hoisted_3, " No one distributor is available "))
        ])
      ], 32)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_bs5_cancel_button, { onClick: _ctx.closeModal }, null, 8, ["onClick"]),
      _createVNode(_component_bs5_save_button, {
        loading: _ctx.saving,
        onClick: _ctx.assignDistributor
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Assign")
        ])),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
}